<!-- PAGE TITLE
        ================================================== -->
<section class="page-title-section bg-img cover-background top-position1 left-overlay-dark" data-overlay-dark="9"
         data-background="img/bg/bg-04.jpg"
         style="background-image: url(assets/img/bg/bg-04.jpg);">
    <div class="container">
        <div class="row text-center">
            <div class="col-md-12">
                <h1>Career</h1>
            </div>
            <div class="col-md-12">
                <ul>
                    <li><a routerLink="/">Home</a></li>
                    <li><a href="#!">Career</a></li>
                </ul>
            </div>
        </div>
    </div>
</section>

<!-- CONTACT FORM
================================================== -->
<section class="bg-very-light-gray py-md-8 pb-lg-0">
    <div class="container">
        <div class="row ">
            <div class="col-lg-6 col-md-6 col-sm-6">
                <img src="assets/img/hostel/Cjobs.jpeg" alt="...">
            </div>
            <div class="col-lg-6 col-md-6 col-sm-6 mb-5">
                <div class="faq-form">
                    <h2 class="mb-4 text-primary">Career Form</h2>
                    <form [formGroup]="addCareerForm" class="contact quform" id="form"
                          action="https://elearn.websitelayout.net/quform/contact.php"
                          method="post" enctype="multipart/form-data" onclick="">
                        <div class="quform-elements">
                            <div class="row">

                                <!-- Begin Text input element -->
                                <div class="col-md-6">
                                    <div class="quform-element form-group">
                                        <label for="name"> Name <span class="quform-required">*</span></label>
                                        <div class="quform-input">
                                            <input class="form-control" id="name" type="text" formControlName="name"
                                                   placeholder="Enter your name"/>
                                        </div>
                                    </div>
                                </div>
                                <!-- End Text input element -->

                                <!-- Begin Text input element -->
                                <div class="col-md-6">
                                    <div class="quform-element form-group">
                                        <label for="email"> Email <span class="quform-required">*</span></label>
                                        <div class="quform-input">
                                            <input class="form-control" id="email" type="text" formControlName="email"
                                                   placeholder="Enter your email"/>
                                        </div>
                                    </div>
                                </div>
                                <!-- End Text input element -->

                                <!-- Begin Text input element -->
                                <div class="col-md-6">
                                    <div class="quform-element form-group">
                                        <label for="subject">Experience <span class="quform-required">*</span></label>
                                        <div class="quform-input">
                                            <input class="form-control" id="subject" type="text"
                                                   formControlName="experience"
                                                   placeholder="Your Experience"/>
                                        </div>
                                    </div>
                                </div>
                                <!-- End Text input element -->

                                <!-- Begin Text input element -->
                                <div class="col-md-6">
                                    <div class="quform-element form-group">
                                        <label for="phone">Contact Number</label>
                                        <div class="quform-input">
                                            <input class="form-control" id="phone" type="text" formControlName="contact"
                                                   placeholder="Enter your contact"/>
                                        </div>
                                    </div>
                                </div>
                                <!-- End Text input element -->

                                <!-- Begin Textarea element -->
                                <div class="col-md-12">
                                    <div class="quform-element form-group">
                                        <label>Applied For <span class="quform-required">*</span></label>
                                        <div class="quform-input">
                                            <select class="form-control " formControlName="applied_for" >
                                                <option value="">Select Job Title</option>
                                                <option *ngFor="let jobTitle of jobTitles" value="{{jobTitle}}">{{jobTitle}}</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-6">
                                        <button (click)="resume.click()"
                                                class="btn btn-primary color-white my-3 w-100" title="Upload">
                                            <i class="fas fa-cloud-upload-alt"></i> Upload Resume
                                        </button>
                                        <input #resume (change)="onFileChange($event)"
                                               class="form-control-file display-hidden display-none"
                                               style="display: none;"
                                               type="file">
                                    </div>
                                    <div class="col-6">
                                        <button *ngIf="image!=null" (click)="goTo(image?.url)"
                                                class="btn btn-primary color-white my-3 px-1 w-100"
                                                title="Upload">
                                            <i class="fas fa-eye"></i> Preview
                                        </button>
                                    </div>
                                </div>


                                <!-- End Textarea element -->

                                <!-- Begin Submit button -->
                                <div class="col-md-12">
                                    <div class="quform-submit-inner">
                                        <button class="butn secondary" type="submit"><i
                                            class="far fa-paper-plane icon-arrow before"></i><span class="label"
                                                                                                   (click)="submit()">Send Message</span><i
                                            class="far fa-paper-plane icon-arrow after"></i></button>
                                    </div>
                                    <div class="quform-loading-wrap text-start"><span class="quform-loading"></span>
                                    </div>
                                </div>
                                <!-- End Submit button -->

                            </div>
                        </div>
                    </form>
                </div>
            </div>

            <div class="col-12">
                <div class="card w-100 my-5" *ngFor="let jobOpening of jobOpenings;">
                    <div class="card-header">Job Title - <b>{{ jobOpening?.title }}</b></div>
                    <div class="card-body">
                        <h6>Qualification :</h6>
                        <p>{{ jobOpening?.qualification }}</p>

                        <h6>Experience :</h6>
                        <p>{{ jobOpening?.experience }}</p>

                        <h6>Region :</h6>
                        <p>{{ jobOpening?.region }}</p>

                        <h6>Country :</h6>
                        <p>{{ jobOpening?.country }}</p>

                        <h6>Department :</h6>
                        <p>{{ jobOpening?.industry }}</p>

                        <h6>Skill Required :</h6>
                        <p [innerHTML]="jobOpening?.skills_required"></p>

                    </div>
                    <div class="card-footer"><button class="btn btn-primary" (click)="goToTop()">Apply Now</button></div>
                </div>
            </div>
        </div>
    </div>
</section>
